/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Period of stay
 * @export
 * @interface TravelineBookingStayDatesDto
 */
export interface TravelineBookingStayDatesDto {
    /**
     * Check-in date and time according to local hotel time.<br />
     * The format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {string}
     * @memberof TravelineBookingStayDatesDto
     */
    arrivalDateTime: string;
    /**
     * Check-out date and time according to local hotel time.<br />
     * The format complies with ISO-8601 YYYY-MM-DDThh:mm
     * @type {string}
     * @memberof TravelineBookingStayDatesDto
     */
    departureDateTime: string;
}

/**
 * Check if a given object implements the TravelineBookingStayDatesDto interface.
 */
export function instanceOfTravelineBookingStayDatesDto(value: object): value is TravelineBookingStayDatesDto {
    if (!('arrivalDateTime' in value) || value['arrivalDateTime'] === undefined) return false;
    if (!('departureDateTime' in value) || value['departureDateTime'] === undefined) return false;
    return true;
}

export function TravelineBookingStayDatesDtoFromJSON(json: any): TravelineBookingStayDatesDto {
    return TravelineBookingStayDatesDtoFromJSONTyped(json, false);
}

export function TravelineBookingStayDatesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingStayDatesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'arrivalDateTime': json['arrivalDateTime'],
        'departureDateTime': json['departureDateTime'],
    };
}

  export function TravelineBookingStayDatesDtoToJSON(json: any): TravelineBookingStayDatesDto {
      return TravelineBookingStayDatesDtoToJSONTyped(json, false);
  }

  export function TravelineBookingStayDatesDtoToJSONTyped(value?: TravelineBookingStayDatesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arrivalDateTime': value['arrivalDateTime'],
        'departureDateTime': value['departureDateTime'],
    };
}

